<template>
  <div class="xy-toolbar-wrapper xy-toolbar-ui xy-ui-element">
    <ul class="xy-toolbar">
      <slot></slot>
      <xy-toolbox-menu-item
        v-for="it in menu_items"
        :key="it.link"
        :icon="it.icon"
        @click="it.handle ? it.handle : {}"
        :actived="current == it.name"
        :href="it.link"
        style="margin-right: 30px"
      >
        {{ it.name }}  
      </xy-toolbox-menu-item>

      <xy-toolbox-menu-item custom>
        <slot name="button"></slot>
      </xy-toolbox-menu-item>
    </ul>
  </div>
</template>
<script>
import Permissions from "../../store/permissions.js";

export default {
  props: {
    items: Array,
    current: String,
  },
  data() {
    return {};
  },
  methods: {},
  created() {},

  mounted() {},
  computed: {
    menu_items() {
    var ls = [];
    if(!this.items)
      return ls;
    let chk_list = ["装备表","装备梯度","子车型对比","车款对比","装备率","子车型销量","车款销量","装备销量","生命周期研究" ,"装车率","客户价值分析","日报","月报"];
        for(let x of this.items)
        {
           if(x.name=="装备表" && Permissions.Client_ViewLine_EqData())
             {
                  ls.push(x);
             }else if(x.name=="装备梯度" && Permissions.Client_ViewLine_Gradient()){
                  ls.push(x);
             }else if(x.name=="子车型对比" && Permissions.Client_ViewLine_ModelEq()){
                  ls.push(x);
             }else if(x.name=="车款对比" && Permissions.Client_ViewLine_LineEq()){
                  ls.push(x);
             }else if(x.name=="装备率" && Permissions.Client_ViewAnalysis_EqRate()){
                  ls.push(x);
             }


             else if(x.name=="子车型销量" && Permissions.Client_ViewSales_Model()){
                  ls.push(x);
             }else if(x.name=="车款销量" && Permissions.Client_ViewSales_Line()){
                  ls.push(x);
             }else if(x.name=="装备销量" && Permissions.Client_ViewSales_Eq()){
                  ls.push(x);
             }


            else if(x.name=="生命周期研究" && Permissions.Client_ViewAnalysis_LifeCycle()){
                  ls.push(x);
             }else if(x.name=="装车率" && Permissions.Client_ViewAnalysis_EqRate()){
                  ls.push(x);
             }else if(x.name=="客户价值分析" && Permissions.Client_ViewAnalysis_Pva()){
                  ls.push(x);
             }else if(x.name=="日报" && Permissions.Client_ViewReport_Day()){
                  ls.push(x);
             }else if(x.name=="月报" && Permissions.Client_ViewReport_Month()){
                  ls.push(x);
             }else if(! chk_list.includes(ls.name))
             {

                  ls.push(x);
             }

         
        }
        return ls;

    },
  },
};
</script>
